module.exports = __webpack_public_path__ + "img/cyclops.eeef4d43.jpg";